<template>
  <div v-if="grantsConstraintsPlansData" class="">
    <div class="table-container">
      <table class="my-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ $t("GrantsConstraintsPlans.code") }}</th>
            <th>{{ $t("GrantsConstraintsPlans.name") }}</th>
            <th>{{ $t("notes") }}</th>
            <th>{{ $t("info") }}</th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              {{ $t("edit") }}
            </th>
            <th
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              {{ $t("delete") }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(GrantsConstraintsPlan, index) in grantsConstraintsPlansData"
            :key="index"
          >
            <td>{{ ++index + pagination.currentIndex }}</td>
            <td>
              {{
                isDataExist(GrantsConstraintsPlan.grantsConstraintsPlansCode)
              }}
            </td>
            <td>
              {{
                isDataExist(
                  GrantsConstraintsPlan.grantsConstraintsPlansNameCurrent
                )
              }}
            </td>
            <td>
              {{
                isDataExist(GrantsConstraintsPlan.grantsConstraintsPlansNote)
              }}
            </td>
            <!-- <td>
              <button
                v-b-modal.GrantsConstraintsPlanInfo
                class="btn p-0"
                :title="$t('info')"
                @click="setGrantsConstraintsPlan(GrantsConstraintsPlan)"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </button>
            </td> -->
            <td>
              <router-link
                :to="{
                  name: 'GrantsConstraintsPlansSlidesDetails',
                  params: {
                    grantsConstraintsPlansToken:
                      GrantsConstraintsPlan.grantsConstraintsPlansToken,
                  },
                }"
                :title="$t('info')"
              >
                <img src="@/assets/images/info.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsUpdate
                )
              "
            >
              <router-link
                :to="{
                  name: 'GrantsConstraintsPlanEdit',
                  params: {
                    grantsConstraintsPlansToken:
                      GrantsConstraintsPlan.grantsConstraintsPlansToken,
                  },
                }"
                :title="$t('edit')"
              >
                <img src="@/assets/images/pencil.svg" class="icon-lg" />
              </router-link>
            </td>
            <td
              v-if="
                checkPrivilege(
                  usersEstablishmentPrivilegeData
                    .usersPrivilegAdditionalSettings.additionalSettingsArchive
                )
              "
            >
              <button
                v-b-modal.GrantsConstraintsPlanDelete
                class="btn p-0"
                :title="$t('delete')"
                @click="setGrantsConstraintsPlan(GrantsConstraintsPlan)"
              >
                <img src="@/assets/images/trash.svg" class="icon-lg" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import privilegeMixin from "@/utils/privilege-mixin";
import { formateDateTimeLang, isDataExist } from "@/utils/functions";

export default {
  mixins: [privilegeMixin],
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
    };
  },
  props: ["grantsConstraintsPlansData", "pagination"],
  methods: {
    setGrantsConstraintsPlan(data) {
      this.$emit("setGrantsConstraintsPlan", data);
    },
    formateDateTimeLang(date, time) {
      return formateDateTimeLang(date, time, this.language);
    },
    isDataExist,
  },
  computed: {},
  async created() {},
};
</script>
